/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import Calendar from './calendar/hu_HU';
import DatePicker from './date-picker/hu_HU';
import Pagination from './pagination/hu_HU';
import TimePicker from './time-picker/hu_HU';

export default {
  locale: 'hu',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'SzÅ±rÅk',
    filterConfirm: 'AlkalmazÃ¡s',
    filterReset: 'VisszaÃ¡llÃ­tÃ¡s',
    selectAll: 'Jelenlegi oldal kivÃ¡lasztÃ¡sa',
    selectInvert: 'Jelenlegi oldal inverze',
    sortTitle: 'RendezÃ©s'
  },
  Modal: {
    okText: 'AlkalmazÃ¡s',
    cancelText: 'VisszavonÃ¡s',
    justOkText: 'AlkalmazÃ¡s'
  },
  Popconfirm: {
    okText: 'AlkalmazÃ¡s',
    cancelText: 'VisszavonÃ¡s'
  },
  Transfer: {
    searchPlaceholder: 'KeresÃ©s',
    itemUnit: 'elem',
    itemsUnit: 'elemek'
  },
  Upload: {
    uploading: 'FeltÃ¶ltÃ©s...',
    removeFile: 'FÃ¡jl eltÃ¡volÃ­tÃ¡sa',
    uploadError: 'FeltÃ¶ltÃ©si hiba',
    previewFile: 'FÃ¡jl elÅnÃ©zet'
  },
  Empty: {
    description: 'Nincs adat'
  }
};
